import { Badge } from "../../../../../shared/components/badge/Badge";

const TacticLineCurrentStatusBadge = ({ value }) => {
  const calculateBadgeColor = (value) => {
    switch (value) {
      case "ACTIVATED":
        return "border-transparent bg-[#28A745] text-primary-foreground shadow hover:bg-[#28A745]/80";
      case "DEACTIVATED":
        return "border-transparent bg-[#DC3545] text-primary-foreground shadow hover:bg-[#DC3545]/80";
      case "DELETED":
        return "border-transparent bg-[#6C757D] text-primary-foreground shadow hover:bg-[#6C757D]/80";
      case "Unknown":
        return "border-transparent bg-[#FFC107] text-primary-foreground shadow hover:bg-[#FFC107]/80";
      default:
        break;
    }
  };

  return <Badge className={calculateBadgeColor(value)}>{value}</Badge>;
};

export default TacticLineCurrentStatusBadge;
